/**
 * 服务站1楼层平面布局情况图
 * 使用canvas进行展示的绘制
 */
import React from 'react';


import { copyObject } from '../../../util/util.js';

import moment from 'moment';
import ContractManageDetail from '../contractManage/ContractManageDetail'
import http from '../../../axios/http';
import messager from '../../ui/messager';


//四周围墙信息
const wallData = [{
    x: 50, y: 50
}
,{
    x: 1492, y: 50
}
,{
    x: 1492, y: 686
}
,{
    x: 1061, y: 686
}
,{
    x: 50, y: 686
}
//回到原点，如果50,50会有缺口
,{         
    x: 50, y: 46
}];

//楼层信息情况
const floorData = [
{
    code: '1', label: 'M4-F1-1', data: [{ x: 55, y: 55, label: 'M4-F1-1', fontX: 70, fontY: 70}, { x: 1487, y: 55 }, { x: 1487, y: 267 }, { x: 1368, y: 267 }, { x: 1368, y: 267 }, { x: 1368, y: 505 }, { x: 1249, y: 505 }, { x: 1249, y: 680 },{ x: 532, y: 680 },{ x: 532, y: 505 },{ x: 174, y: 505 }, { x: 174, y: 267 } ,{ x: 55, y: 267 }], type: "other", width: 100, height: 100, color: '#60acfc'
}
,{
    code: 'staircase', label: '楼梯', x: 55, y: 267, width: 119, height: 238, color: '#DDDDDD'
}
,{
    code: 'staircase', label: '楼梯', x: 1368, y: 267, width: 119, height: 238, color: '#DDDDDD'
}
,{
    code: '103', label: 'M4-F1-103', x: 55, y: 505, width: 238, height: 175, color: '#60acfc'
}
,{
    code: '104', label: 'M4-F1-104', x: 293, y: 505, width: 239, height: 175, color: '#60acfc'
}
,{
    code: 'toilet', label: '卫生间', x: 1249, y: 505, width: 238, height: 175, color: '#DDDDDD'
}
// ,{
//     code: 'M2-C2-2', label: 'C2-2', data: [{ x: 286, y: 597, label: 'C2-2', fontX: 309, fontY: 620}, { x: 790, y: 597 }, { x: 790, y: 597 }, { x: 790, y: 761 }, { x: 430, y: 715 }, { x: 286, y: 709 }], type: "other", width: 504, height: 112, color: '#60acfc'
// }
// ,{
//     code: 'finance', label: '财务室', x: 532, y: 55, width: 239, height: 212, color: '#DDDDDD'
// }
// ,{
//     code: 'meeting', label: '会议室', x: 1249, y: 55, width: 238, height: 212, color: '#DDDDDD'
// }
// ,{
//     code: 'staircase', label: '楼梯', x: 1368, y: 267, width: 119, height: 238, color: '#DDDDDD'
// }
// ,{
//     code: 'manager', label: '总经理室', x: 532, y: 505, width: 239, height: 175,color: '#DDDDDD'
// }
// ,{
//     code: 'officeOne', label: '汽协办公室', x: 771, y: 505, width: 239, height: 175, color: '#DDDDDD'
// }
// ,{
//     code: 'officeTwo', label: '招商IT办公室', x: 1010, y: 505, width: 239, height: 175, color: '#DDDDDD'
// }
// ,{
//     code: 'toilet', label: '卫生间', x: 1249, y: 505, width: 238, height: 175, color: '#DDDDDD'
// }
];

const defaultSetting = {
    fontColor: '#FFFFFF',
    font: "14px Arial",
    borderColor: "#FFFFFF",
    colors: ["#32d3eb", "#5bc49f", "#feb64d", "#ff7c7c", "#9287e7"],
    wallColor: "#CCCCCC",
    hoverColor: "rgba(253, 221, 49, 1)"
};


class JiMeiExhibitionM4F1 extends React.Component {

    state = {
        canvasDom: '',      //画布节点
        canvasCtx: null,      //画布对象
        canvasWidth: 0,     //画布的宽
        canvasHeight: 0,    //画布的高

        floorData: copyObject(floorData),      //楼层信息

        initDrawFlag: false,    //是否已经初始化了绘图

        currentHoverArea: null, //当前鼠标悬浮的区域块编码
        sameContractBerth: {}, //与当前鼠标悬浮的区域相同合同的区域块编码


        tipX: 0,    //提示框的位置
        tipY: 0,    //提示框的位置

        initScale: 1,   //初始的尺寸
        scale: 1,       //放大缩小尺寸
        maxScale: 5,    //最大缩放比例
        dragX: 0,       //拖拽X
        dragY: 0,        //拖拽Y

        detailVisible: false,
        detailData:{},

    }

    constructor(props) {
        super(props);
        this.canvas = React.createRef();
        this.canvasDiv = React.createRef();
        
    }

    componentDidMount() {
        //计算获得画布的宽和高
        this.calculatedAltitude();
        //获取canvas的dom节点
        const canvasDom = this.canvas.current;
        const canvasCtx = canvasDom.getContext("2d");
        this.setState({ canvasDom: canvasDom, canvasCtx: canvasCtx });
        // this.setBerthInfo();    //设置铺位信息
        canvasDom.addEventListener('click', this.handleClick);
        //鼠标悬停事件
        canvasDom.addEventListener('mousemove', this.handleMouseMove);
        //滚轮放大缩小事件
        canvasDom.addEventListener('wheel', this.handleWheel);
        //鼠标点击拖拽事件
        canvasDom.addEventListener('mousedown', this.handleMouseDown);
        //监听窗口大小改变
        window.addEventListener('resize', this.handleResize, false);
    }

    componentDidUpdate() {
        let { canvasCtx, initDrawFlag, scale } = this.state;
        if (canvasCtx != null && !initDrawFlag) {
            canvasCtx.scale(scale, scale);
            this.drawFloorLayout();
            this.setState({ initDrawFlag: true });
        }
    }
    

    componentWillUnmount() {
        //一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener('resize', this.handleResize, false);
    }

    handleResize = e => {
        this.calculatedAltitude();
    }

    //计算画布宽度和高度
    calculatedAltitude = () => {
        let div = this.canvasDiv.current;
        let canvasWidth = div.clientWidth || div.offsetWidth;
        let canvasHeight = div.clientHeight || div.offsetHeight;

        let scale = 1;
        // 标准情况下的画布宽度
        if (canvasWidth < 1500 || canvasWidth > 2000) {
            scale = canvasWidth / 1500;
        }
        this.setState({ canvasWidth: canvasWidth, canvasHeight: canvasHeight, initDrawFlag: false, dragX: 0, dragY: 0, scale: scale, initScale: scale });
    }

    /**
     * 调整铺位的信息
     * @param {*} berthRent 已经出租的铺位信息
     */
    setBerthInfo = (berthRent) => {
        let berth = copyObject(floorData);  //基本的铺位信息
        let sameContractBerth = {};         //合同号相同的铺位信息
        let map = {};
        berth.forEach((item, index) => {
            map[item.code] = item;
        });
        if (berthRent != null && berthRent.length > 0) {
            let reminderDate = moment().add(1, 'M').format("YYYY-MM-DD");
            berthRent.forEach((item, index) => {
                let berth = map[item.berthCode];
                if (berth != null) {
                    berth["buildingArea"] = item["buildingArea"];
                    berth["text"] = item["clientName"];
                    berth["effectDate"] = item["effectDate"];
                    berth["invalidDate"] = item["invalidDate"];
                    berth["contractId"] = item["contractId"];
                    if (berth["invalidDate"] < reminderDate) {
                        berth["color"] = defaultSetting.colors[2];
                    } else {
                        berth["color"] = defaultSetting.colors[1];
                    }
                    //合同号相同的放一起，便于处理
                    let berths = sameContractBerth[item["contractId"]];
                    if (berths == null) berths = [];
                    berths.push(berth);
                    sameContractBerth[item["contractId"]] = berths;
                }
            });
        }
        let scale = this.state.initScale / this.state.scale;
        this.setState({ floorData: berth, sameContractBerth: sameContractBerth, initDrawFlag: false, dragX: 0, dragY: 0, scale: scale, initScale: scale });
    }
    handleClick=(event)=>{
        let floorData = this.state.floorData;
        let ctx = this.state.canvasCtx;
        let x = event.offsetX;
        let y = event.offsetY;
        let currentHoverArea = this.state.currentHoverArea; //当前鼠标悬停的区域块编码
        let newHoverArea = null;
        let newHoverAreas;
        for (let index in floorData) {
            let item = floorData[index];
            let area = item.area;
            if (area != null) {
                if (ctx.isPointInPath(area, x, y)) {
                    console.log(newHoverAreas[0])
                    newHoverArea = item;
                    //合同编号相同的同时高亮
                    newHoverAreas = this.state.sameContractBerth[newHoverArea.contractId];
                    if (newHoverAreas == null) newHoverAreas = [newHoverArea];
                    if(newHoverAreas[0].contractId!==undefined){
                        this.deatil(newHoverAreas[0].contractId);
                        this.setState({visible:true})
                    }else{
                        console.log('1')
                         messager.notify("暂无关联合同！");
                    }
                    break;
                }
            }
        }
        if (currentHoverArea == null) {
            if (newHoverArea == null) {
                //不做任何处理
            } else {
                // this.drawFloorLayout();
                // ctx.fillStyle = defaultSetting.hoverColor;
                // ctx.fill(newHoverArea.area);
                // this.drawRect(newHoverArea, defaultSetting.hoverColor, 1, newHoverArea.lineColor, ctx);
                this.mouseMoveDraw(newHoverAreas, defaultSetting.hoverColor);
                this.setState({ currentHoverArea: newHoverArea });
            }
        } else {
            //合同编号相同的同时高亮
            let currentHoverAreas = this.state.sameContractBerth[currentHoverArea.contractId];
            if (currentHoverAreas == null) currentHoverAreas = [currentHoverArea];
            //判断高亮处理
            if (newHoverArea == null) {
                // this.drawRect(currentHoverArea, currentHoverArea.color, 1, currentHoverArea.lineColor, ctx);
                this.mouseMoveDraw(currentHoverAreas, currentHoverArea.color);
                this.setState({ currentHoverArea: null });
            } else if (currentHoverArea.code === newHoverArea.code) {
                //如果相同则不做任何处理
            } else {
                // this.drawRect(currentHoverArea, currentHoverArea.color, 1, currentHoverArea.lineColor, ctx);
                // this.drawRect(newHoverArea, defaultSetting.hoverColor, 1, newHoverArea.lineColor, ctx);
                this.mouseMoveDraw(currentHoverAreas, currentHoverArea.color);
                this.mouseMoveDraw(newHoverAreas, defaultSetting.hoverColor);
                // this.drawFloorLayout();
                // ctx.fillStyle = defaultSetting.hoverColor;
                // ctx.fill(newHoverArea.area);
                this.setState({ currentHoverArea: newHoverArea });
            }
        }
        if (newHoverArea != null) {
            this.setState({ tipX: x + 20, tipY: y + 20 });
        }
    }
    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }
    deatil=(id)=>{
            http.get({
                url: '/market/contract/query/contractAndBills/' + id,
                success: (res) => {
                    //租金标准
                let rentStandardList = res.rentStandardList;
                if (rentStandardList) {
                    if (rentStandardList !== null && rentStandardList !== undefined) {
                        for (let index in rentStandardList) {
                            rentStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            rentStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                else {
                    rentStandardList = [];
                }
                //物管费标准
                let busiFeeStandardList = [];
                if (res.busiManageContractVO && res.busiManageContractVO.busiFeeStandardList && res.busiManageContractVO.busiFeeStandardList.length > 0) {
                    busiFeeStandardList = res.busiManageContractVO.busiFeeStandardList;
                    if (busiFeeStandardList !== null && busiFeeStandardList !== undefined) {
                        for (let index in busiFeeStandardList) {
                            busiFeeStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            busiFeeStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                this.state.initDetail(rentStandardList, busiFeeStandardList, res.berthIds, res.freeMonth);
                    this.transferData(res, "partybAccount");
                    this.transferData(res, "partybContactInfo");
                    this.transferData(res, "busiManageContractVO");
                    let allMoney = 0;  //总金额
                    let payCount = 0; // 已付账单次数
                    let payMoney = 0; //已付金额
                    if (res['billList'] !== undefined) {
                        for (let i = 0; i < res['billList'].length; i++) {
                            allMoney += res['billList'][i].totalAmount;
                            if (res['billList'][i].status === '1') {
                                payCount++;
                                payMoney += res['billList'][i].totalAmount
                            }
                        }
                        res.allMoney = allMoney;
                        res.payMoney = payMoney;
                        res.payProportion = ((payCount / res['billList'].length) * 100).toFixed(2);   // 已付账单完成比例
                    }
                    this.setState({ detailData: res, detailVisible: true });
                }
            });
    }
    hiddenDetailModal = () => {
        this.setState({ detailVisible: false });
    }
  
    /**  鼠标悬停在画布上  */
    handleMouseMove = (event) => {
        let floorData = this.state.floorData;
        let ctx = this.state.canvasCtx;
        let x = event.offsetX;
        let y = event.offsetY;
        let currentHoverArea = this.state.currentHoverArea; //当前鼠标悬停的区域块编码
        let newHoverArea = null;
        let newHoverAreas;
        for (let index in floorData) {
            let item = floorData[index];
            let area = item.area;
            if (area != null) {
                if (ctx.isPointInPath(area, x, y)) {
                    newHoverArea = item;
                    //合同编号相同的同时高亮
                    newHoverAreas = this.state.sameContractBerth[newHoverArea.contractId];
                    if (newHoverAreas == null) newHoverAreas = [newHoverArea];
                    break;
                }
            }
        }
        if (currentHoverArea == null) {
            if (newHoverArea == null) {
                //不做任何处理
            } else {
                // this.drawFloorLayout();
                // ctx.fillStyle = defaultSetting.hoverColor;
                // ctx.fill(newHoverArea.area);
                // this.drawRect(newHoverArea, defaultSetting.hoverColor, 1, newHoverArea.lineColor, ctx);
                this.mouseMoveDraw(newHoverAreas, defaultSetting.hoverColor);
                this.setState({ currentHoverArea: newHoverArea });
            }
        } else {
            //合同编号相同的同时高亮
            let currentHoverAreas = this.state.sameContractBerth[currentHoverArea.contractId];
            if (currentHoverAreas == null) currentHoverAreas = [currentHoverArea];
            //判断高亮处理
            if (newHoverArea == null) {
                // this.drawRect(currentHoverArea, currentHoverArea.color, 1, currentHoverArea.lineColor, ctx);
                this.mouseMoveDraw(currentHoverAreas, currentHoverArea.color);
                this.setState({ currentHoverArea: null });
            } else if (currentHoverArea.code === newHoverArea.code) {
                //如果相同则不做任何处理
            } else {
                // this.drawRect(currentHoverArea, currentHoverArea.color, 1, currentHoverArea.lineColor, ctx);
                // this.drawRect(newHoverArea, defaultSetting.hoverColor, 1, newHoverArea.lineColor, ctx);
                this.mouseMoveDraw(currentHoverAreas, currentHoverArea.color);
                this.mouseMoveDraw(newHoverAreas, defaultSetting.hoverColor);
                // this.drawFloorLayout();
                // ctx.fillStyle = defaultSetting.hoverColor;
                // ctx.fill(newHoverArea.area);
                this.setState({ currentHoverArea: newHoverArea });
            }
        }
        if (newHoverArea != null) {
            this.setState({ tipX: x + 20, tipY: y + 20 });
        }
    }

    /**
     * 鼠标悬浮的时候显示图标情况
     * @param {*} areas 要显示的区域，数组格式
     * @param {*} color 显示的颜色
     */
    mouseMoveDraw = (areas, color) => {
        let ctx = this.state.canvasCtx;
        areas.forEach(area => {
            this.drawRect(area, color, 1, area.lineColor, ctx);
        });
    }

    /** 滚轮滚动事件 */
    handleWheel = (event) => {
        let ctx = this.state.canvasCtx;
        if (ctx == null) return;
        //判断鼠标滚轮的上下滑动
        let delta = event.deltaY
        if (delta > 0) {
            // 缩小
            let scale = this.state.scale * 0.8;
            this.setState({ scale: scale });
            ctx.scale(0.8, 0.8);
            this.drawFloorLayout();
        } else if (delta < 0) {
            // 放大
            let scale = this.state.scale * 1.25;
            if (scale < this.state.maxScale) {
                this.setState({ scale: scale });
                ctx.scale(1.25, 1.25);
            }
            this.drawFloorLayout();
        }
    }



    /** 鼠标点击拖拽事件 */
    handleMouseDown = (event) => {
        let startX = event.clientX - event.target.offsetLeft;
        let startY = event.clientY - event.target.offsetTop;
        let dragging = true;
        document.onmousemove = (e) => {
            if (dragging) {
                //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let x = e.clientX - startX;
                let y = e.clientY - startY;
                this.setState({
                    dragX: x,
                    dragY: y
                })
            }
        }

        document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
            dragging = false;
        };
    }


    /** 绘制楼层布局情况 */
    drawFloorLayout = () => {
        let ctx = this.state.canvasCtx;
        if (ctx != null) {
            ctx.clearRect(0, 0, 10000, 10000);   //清除画布
            this.drawArea(wallData, 10, defaultSetting.wallColor, null, ctx);    //绘制外墙
            this.drawBerth();   //绘制各个铺位
        }
    }

    //绘制楼层布局图
    drawBerth = () => {
        let selectFloor = this.props.selectFloor;
        let floorData = this.state.floorData;
        let canvasCtx = this.state.canvasCtx;
        if (canvasCtx != null) {
            floorData.forEach((item, index) => {
                if(selectFloor===1&&item.code==='13'){
                    return
                }
                let lineStyle = item.lineColor ? item.lineColor : defaultSetting["borderColor"];
                let area = this.drawRect(item, item.color, 1, lineStyle, canvasCtx);
                if (item.code !== "middle") {
                    item.area = area;
                }
            });

        }
    }

    /**
     * 绘制矩形
     * @param {*} data      用于绘制矩形的数据
     * @param {*} fillStyle 矩形的填充颜色
     * @param {*} lineWidth 矩形的线宽
     * @param {*} strokeStyle 矩形的线条颜色
     * @param {*} ctx  画布队形
     */
    drawRect = (data, fillStyle, lineWidth, strokeStyle, ctx) => {
        let area = null;
        if (data.radius != null) {
            //需要圆角的矩形
            let topLeft = 0, topRight = 0, bottomLeft = 0, bottomRight = 0;
            if (data.radius.length === 1) {
                topLeft = data.radius[0];
                topRight = data.radius[0];
                bottomRight = data.radius[0];
                bottomLeft = data.radius[0];
            } else if (data.radius.length === 2) {
                topLeft = data.radius[0];
                topRight = data.radius[0];
                bottomRight = data.radius[1];
                bottomLeft = data.radius[1];
            } else if (data.radius.length === 4) {
                topLeft = data.radius[0];
                topRight = data.radius[1];
                bottomRight = data.radius[2];
                bottomLeft = data.radius[3];
            }
            let drawData = [];
            //起始位置
            if (topLeft > 0) {
                drawData.push({ x: data.x + topLeft, y: data.y, label: data.label });
            } else {
                drawData.push({ x: data.x, y: data.y, label: data.label });
            }
            //画直线和圆角，如果需要圆角的话
            if (topRight > 0) {
                drawData.push({ x: data.x + data.width - topRight, y: data.y });
                drawData.push({ x: data.x + data.width - topRight, y: data.y + topRight, r: topRight, sAngle: 1.5 * Math.PI, eAngle: 0, counterclockwise: false, arc: true });
            } else {
                drawData.push({ x: data.x + data.width, y: data.y });
            }
            if (bottomRight > 0) {
                drawData.push({ x: data.x + data.width, y: data.y + data.height - bottomRight });
                drawData.push({ x: data.x + data.width - bottomRight, y: data.y + data.height - bottomRight, r: bottomRight, sAngle: 0, eAngle: 0.5 * Math.PI, counterclockwise: false, arc: true });
            } else {
                drawData.push({ x: data.x + data.width, y: data.y + data.height });
            }
            if (bottomLeft > 0) {
                drawData.push({ x: data.x + bottomLeft, y: data.y + data.height });
                drawData.push({ x: data.x + bottomLeft, y: data.y + data.height - bottomLeft, r: bottomLeft, sAngle: 0.5 * Math.PI, eAngle: Math.PI, counterclockwise: false, arc: true });
            } else {
                drawData.push({ x: data.x, y: data.y + data.height });
            }
            if (topLeft > 0) {
                drawData.push({ x: data.x, y: data.y + topLeft });
                drawData.push({ x: data.x + topLeft, y: data.y + topLeft, r: topLeft, sAngle: Math.PI, eAngle: 1.5 * Math.PI, counterclockwise: false, arc: true });
            } else {
                drawData.push({ x: data.x, y: data.y });
            }
            //绘制区域
            area = this.drawArea(drawData, lineWidth, strokeStyle, fillStyle, ctx);
        } else if (data.type === "other") {
            area = this.drawArea(data.data, lineWidth, strokeStyle, fillStyle, ctx);
        }else {
            //正常矩形
            const rectangle = new Path2D();
            ctx.beginPath();
            rectangle.rect(data.x, data.y, data.width, data.height);
            if (fillStyle != null) {
                ctx.fillStyle = fillStyle;
                ctx.fill(rectangle);
            }
            if (lineWidth != null && lineWidth > 0) {
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = strokeStyle;
                if (data.lineDash != null) {
                    ctx.setLineDash(data.lineDash);
                } else {
                    ctx.setLineDash([0]);
                }
                ctx.stroke(rectangle);
            }
            if (data.label != null && data.label.length > 0) {
                ctx.fillStyle = defaultSetting["fontColor"];
                ctx.font = defaultSetting["font"];
                ctx.fillText(data.label, data.x + 5, data.y + 20);
            }
            area = rectangle;
            ctx.closePath();    //结束绘制
        }
        return area;
    }

    /**
     * 绘制区域块
     * @param {*} data 绘制数据
     * @param {*} lineWidth 线条宽度
     * @param {*} strokeStyle 线条颜色
     * @param {*} fillStyle 填充颜色
     * @param {*} ctx  画布对象
     */
    drawArea = (data, lineWidth, strokeStyle, fillStyle, ctx) => {
        const area = new Path2D();
        ctx.beginPath();    //开始绘制
        data.forEach((item, index) => {
            if (index === 0) {
                //移动到起始位置
                area.moveTo(item.x, item.y);
            } else {
                if (item.arc) {
                    //画圆弧
                    area.arc(item.x, item.y, item.r, item.sAngle, item.eAngle, item.counterclockwise);
                } else {
                    //画直线
                    area.lineTo(item.x, item.y);
                }
            }
        });
        if (lineWidth != null && lineWidth > 0) {
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = strokeStyle;
            ctx.stroke(area);       //绘制
        }
        if (fillStyle != null) {
            ctx.fillStyle = fillStyle;
            ctx.fill(area);         //填充
        }
        if (data[0].label != null && data[0].label.length > 0) {
            ctx.fillStyle = defaultSetting["fontColor"];
            ctx.font = defaultSetting["font"];
            ctx.fillText(data[0].label, data[0].x + 5, data[0].y + 20);
        }
        ctx.closePath();    //结束绘制
        return area;
    }

    render() {
        let { currentHoverArea, sameContractBerth, tipX, tipY, dragX, dragY, canvasHeight, canvasWidth, maxScale } = this.state;
        let label = "";
        if (currentHoverArea != null) {
            label = currentHoverArea.label;
            let berths = sameContractBerth[currentHoverArea["contractId"]];
            if (berths != null && berths.length > 0) {
                label = berths.map((item, index) => item.label).join(",");
            }
        }
        return <div style={{ width: '100%', height: '100%' }} ref={this.canvasDiv}>
            <canvas height={canvasHeight * maxScale} width={canvasWidth * maxScale} style={{ cursor: "pointer", left: dragX, top: dragY, position: 'absolute' }} ref={this.canvas}></canvas>
            {currentHoverArea != null ?
                <div style={{ ...tipDiv, top: tipY + dragY, left: tipX + dragX }}>
                    {label}
                    <br />
                    {currentHoverArea.text}
                    {currentHoverArea.effectDate != null ? <br /> : ""}
                    {currentHoverArea.effectDate != null ? ("租期：" + currentHoverArea.effectDate + "至" + currentHoverArea.invalidDate) : ""}
                </div>
                : ''}
                  <ContractManageDetail
                    successCallback={this.reloadDataFunc}
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenDetailModal.bind(this)}
                    detailData={this.state.detailData}
                    codeList={this.state.codeList}
                    initDetail={(func) => { this.setState({ initDetail: func }) }}
                    type = '1'
                />
                
        </div>
       
    }
}

const tipDiv = {
    position: "absolute",
    zIndex: 99,
    background: 'rgba(50, 50, 50, 0.5)',
    borderWidth: 0,
    borderRadius: 5,
    padding: '5px 15px',
    color: "#FFFFFF",
}


export default JiMeiExhibitionM4F1;